type currencyDataType = {
  symbol: string;
  placement: 'left' | 'right';
};
export const CurrencyList: {
  [key: string]: currencyDataType;
} = {
  AFA: { symbol: '؋', placement: 'right' },
  ALL: { symbol: 'Lek', placement: 'right' },
  DZD: { symbol: 'دج', placement: 'right' },
  AOA: { symbol: 'Kz', placement: 'right' },
  ARS: { symbol: '$', placement: 'left' },
  AMD: { symbol: '֏', placement: 'right' },
  AWG: { symbol: 'ƒ', placement: 'right' },
  AUD: { symbol: '$', placement: 'left' },
  AZN: { symbol: '₼', placement: 'right' },
  BSD: { symbol: 'B$', placement: 'right' },
  BHD: { symbol: '.د.ب', placement: 'right' },
  BDT: { symbol: '৳', placement: 'right' },
  BBD: { symbol: 'Bds$', placement: 'right' },
  BYR: { symbol: 'Br', placement: 'right' },
  BYN: { symbol: 'Br', placement: 'right' },
  BEF: { symbol: 'fr', placement: 'right' },
  BZD: { symbol: 'BZ$', placement: 'right' },
  BMD: { symbol: '$', placement: 'left' },
  BTN: { symbol: 'Nu.', placement: 'right' },
  BOB: { symbol: 'Bs.', placement: 'right' },
  BAM: { symbol: 'KM', placement: 'right' },
  BWP: { symbol: 'P', placement: 'right' },
  BRL: { symbol: 'R$', placement: 'right' },
  GBP: { symbol: '£', placement: 'right' },
  BND: { symbol: 'B$', placement: 'right' },
  BGN: { symbol: 'Лв.', placement: 'right' },
  BIF: { symbol: 'FBu', placement: 'right' },
  KHR: { symbol: '៛', placement: 'right' },
  CAD: { symbol: 'C$', placement: 'left' },
  CVE: { symbol: '$', placement: 'left' },
  CYP: { symbol: '£', placement: 'right' },
  KYD: { symbol: '$', placement: 'left' },
  XOF: { symbol: 'CFA', placement: 'right' },
  XAF: { symbol: 'FCFA', placement: 'right' },
  XPF: { symbol: '₣', placement: 'right' },
  CLP: { symbol: '$', placement: 'left' },
  CNY: { symbol: '¥', placement: 'right' },
  COP: { symbol: '$', placement: 'left' },
  KMF: { symbol: 'CF', placement: 'right' },
  CDF: { symbol: 'FC', placement: 'right' },
  CRC: { symbol: '₡', placement: 'right' },
  HRK: { symbol: 'kn', placement: 'right' },
  CUC: { symbol: 'CUC$', placement: 'right' },
  CUP: { symbol: '₱', placement: 'right' },
  CZK: { symbol: 'Kč', placement: 'right' },
  DKK: { symbol: 'Kr.', placement: 'right' },
  DJF: { symbol: 'Fdj', placement: 'right' },
  DOP: { symbol: 'RD$', placement: 'right' },
  XCD: { symbol: '$', placement: 'left' },
  EGP: { symbol: 'E£', placement: 'right' },
  ERN: { symbol: 'ናቕፋ', placement: 'right' },
  EEK: { symbol: 'kr', placement: 'right' },
  ETB: { symbol: 'ብር', placement: 'right' },
  EUR: { symbol: '€', placement: 'left' },
  FKP: { symbol: '£', placement: 'right' },
  FJD: { symbol: 'FJ$', placement: 'right' },
  GMD: { symbol: 'D', placement: 'right' },
  GEL: { symbol: 'ლ', placement: 'right' },
  DEM: { symbol: 'DM', placement: 'right' },
  GHC: { symbol: 'GH₵', placement: 'right' },
  GHS: { symbol: 'GH₵', placement: 'right' },
  GIP: { symbol: '£', placement: 'right' },
  GRD: { symbol: '₯', placement: 'right' },
  GTQ: { symbol: 'Q', placement: 'right' },
  GGP: { symbol: '£', placement: 'right' },
  GNF: { symbol: 'FG', placement: 'right' },
  GYD: { symbol: '$', placement: 'left' },
  HTG: { symbol: 'G', placement: 'right' },
  HNL: { symbol: 'L', placement: 'right' },
  HKD: { symbol: 'HK$', placement: 'left' },
  HUF: { symbol: 'Ft', placement: 'right' },
  ISK: { symbol: 'kr', placement: 'right' },
  INR: { symbol: '₹', placement: 'right' },
  IDR: { symbol: 'Rp', placement: 'right' },
  IRR: { symbol: '﷼', placement: 'right' },
  IQD: { symbol: 'د.ع', placement: 'right' },
  IMP: { symbol: '£', placement: 'right' },
  ILS: { symbol: '₪', placement: 'right' },
  ITL: { symbol: 'L,£', placement: 'right' },
  JMD: { symbol: 'J$', placement: 'right' },
  JPY: { symbol: '¥', placement: 'right' },
  JEP: { symbol: '£', placement: 'right' },
  JOD: { symbol: 'ا.د', placement: 'right' },
  KZT: { symbol: 'лв', placement: 'right' },
  KES: { symbol: 'KSh', placement: 'right' },
  KWD: { symbol: 'ك.د', placement: 'right' },
  KGS: { symbol: 'лв', placement: 'right' },
  LAK: { symbol: '₭', placement: 'right' },
  LVL: { symbol: 'Ls', placement: 'right' },
  LBP: { symbol: '£', placement: 'right' },
  LSL: { symbol: 'L', placement: 'right' },
  LRD: { symbol: '$', placement: 'left' },
  LYD: { symbol: 'د.ل', placement: 'right' },
  LTL: { symbol: 'Lt', placement: 'right' },
  MTL: { symbol: '₤M', placement: 'right' },
  MOP: { symbol: '$', placement: 'left' },
  MKD: { symbol: 'ден', placement: 'right' },
  MGA: { symbol: 'Ar', placement: 'right' },
  MWK: { symbol: 'MK', placement: 'right' },
  MYR: { symbol: 'RM', placement: 'right' },
  MVR: { symbol: 'Rf', placement: 'right' },
  MRO: { symbol: 'MRU', placement: 'right' },
  MUR: { symbol: '₨', placement: 'right' },
  MXN: { symbol: '$', placement: 'left' },
  MDL: { symbol: 'L', placement: 'right' },
  MNT: { symbol: '₮', placement: 'right' },
  MZN: { symbol: 'MT', placement: 'right' },
  MAD: { symbol: 'MAD', placement: 'right' },
  MZM: { symbol: 'MT', placement: 'right' },
  MMK: { symbol: 'K', placement: 'right' },
  NAD: { symbol: '$', placement: 'left' },
  NPR: { symbol: '₨', placement: 'right' },
  ANG: { symbol: 'ƒ', placement: 'right' },
  TWD: { symbol: 'NT$', placement: 'right' },
  NZD: { symbol: '$', placement: 'left' },
  NIO: { symbol: 'C$', placement: 'right' },
  NGN: { symbol: '₦', placement: 'right' },
  KPW: { symbol: '₩', placement: 'right' },
  NOK: { symbol: 'kr', placement: 'right' },
  OMR: { symbol: 'ر.ع.', placement: 'right' },
  PKR: { symbol: '₨', placement: 'right' },
  PAB: { symbol: 'B/.', placement: 'right' },
  PGK: { symbol: 'K', placement: 'right' },
  PYG: { symbol: '₲', placement: 'right' },
  PEN: { symbol: 'S/.', placement: 'right' },
  PHP: { symbol: '₱', placement: 'right' },
  PLN: { symbol: 'zł', placement: 'right' },
  QAR: { symbol: 'ر.ق', placement: 'right' },
  RON: { symbol: 'lei', placement: 'right' },
  RUB: { symbol: '₽', placement: 'right' },
  RWF: { symbol: 'FRw', placement: 'right' },
  SVC: { symbol: '₡', placement: 'right' },
  WST: { symbol: 'SAT', placement: 'right' },
  SAR: { symbol: '﷼', placement: 'right' },
  RSD: { symbol: 'Дин.', placement: 'right' },
  SCR: { symbol: 'SRe', placement: 'right' },
  SLL: { symbol: 'Le', placement: 'right' },
  SGD: { symbol: '$', placement: 'left' },
  SKK: { symbol: 'Sk', placement: 'right' },
  SBD: { symbol: 'Si$', placement: 'right' },
  SOS: { symbol: 'Sh.so.', placement: 'right' },
  ZAR: { symbol: 'R', placement: 'right' },
  KRW: { symbol: '₩', placement: 'right' },
  XDR: { symbol: 'SDR', placement: 'right' },
  LKR: { symbol: 'Rs', placement: 'right' },
  SHP: { symbol: '£', placement: 'right' },
  SDG: { symbol: '.س.ج', placement: 'right' },
  SSP: { symbol: '£', placement: 'right' },
  SRD: { symbol: '$', placement: 'left' },
  SZL: { symbol: 'E', placement: 'right' },
  SEK: { symbol: 'kr', placement: 'right' },
  CHF: { symbol: 'CHf', placement: 'right' },
  SYP: { symbol: '£S', placement: 'right' },
  STD: { symbol: 'Db', placement: 'right' },
  TJS: { symbol: 'SM', placement: 'right' },
  TZS: { symbol: 'TSh', placement: 'right' },
  THB: { symbol: '฿', placement: 'right' },
  TOP: { symbol: '$', placement: 'left' },
  TTD: { symbol: 'TT$', placement: 'right' },
  TND: { symbol: 'ت.د', placement: 'right' },
  TRY: { symbol: '₺', placement: 'right' },
  TMM: { symbol: 'T', placement: 'right' },
  TMT: { symbol: 'T', placement: 'right' },
  TVD: { symbol: '$', placement: 'left' },
  UGX: { symbol: 'USh', placement: 'right' },
  UAH: { symbol: '₴', placement: 'right' },
  AED: { symbol: 'د.إ', placement: 'right' },
  UYU: { symbol: '$U', placement: 'right' },
  USD: { symbol: '$', placement: 'left' },
  UZS: { symbol: 'лв', placement: 'right' },
  VUV: { symbol: 'VT', placement: 'right' },
  VEF: { symbol: 'Bs', placement: 'right' },
  VND: { symbol: '₫', placement: 'right' },
  YER: { symbol: '﷼', placement: 'right' },
  ZMK: { symbol: 'ZK', placement: 'right' },
  ZWD: { symbol: 'Z$', placement: 'right' },
  BTC: { symbol: '฿₿', placement: 'right' },
  ETH: { symbol: 'Ξ', placement: 'right' },
  USDT: { symbol: '₮', placement: 'right' },
  TUS: { symbol: '₮', placement: 'right' },
  FTN: { symbol: 'FTN', placement: 'right' },
  NSP: { symbol: 'NSP', placement: 'right' }
};
